import { render, staticRenderFns } from "./regulamento.vue?vue&type=template&id=2ea98ab4"
import script from "./regulamento.vue?vue&type=script&lang=js"
export * from "./regulamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports